import './CartSellerComponent.scss';

import PropTypes from 'prop-types';
import React from 'react';

const CartSellerComponent = ({cartData, layoutData}) => {

  return (
    <div className='container'>
      <div className='row'>
        <div className='col-md-6'>
          <dl className='cart-seller'>
            <dt className='cart-seller__title'>{layoutData['Store ID Label'].value}</dt>
            <dd className='cart-seller__description'>{cartData.Staff?.StoreId}</dd>
          </dl>
        </div>
        <div className='col-md-6'>
          <dl className='cart-seller'>
            <dt className='cart-seller__title'>{layoutData['Staff ID Label'].value}</dt>
            <dd className='cart-seller__description'>{cartData.Staff?.StaffId}</dd>
          </dl>
        </div>
      </div>
    </div>
  );
};

CartSellerComponent.propTypes = {
  cartData: PropTypes.any,
  layoutData: PropTypes.any,
};

export default CartSellerComponent;
